/**
 * Platform Detection Utilities
 * Created: December 9, 2024
 *
 * Provides cross-platform detection for Android/iOS-specific behavior.
 */

/**
 * Detect if running on Android
 */
export const isAndroid = () => /Android/i.test(navigator.userAgent);

/**
 * Detect if running on iOS (iPhone, iPad, iPod)
 */
export const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);

/**
 * Detect if running on any mobile device
 */
export const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
